import { useLocation } from 'react-router-dom';
import { VsjEnvironmentReading } from './VsjEnvironmentReading';
import { VsjHome } from './VsjHome';
import { VsjLocationStep } from './VsjLocationStep';
import { VsjMapStage } from './VsjMapStage';
import { VsjPropertyForm } from './VsjPropertyForm';
import { VsjResultStep } from './VsjResultStep';
import { VsjFlowProvider, useVsjFlow } from './vsj-flow';
import type { MockPlace } from './vsj-mocks';
import './vsj-experience.css';

interface RouteState {
  preloadedPlace?: MockPlace;
}

function VsjStepRenderer(): JSX.Element {
  const { step } = useVsjFlow();

  switch (step) {
    case 'home':
      return <VsjHome />;
    case 'location':
      return <VsjLocationStep />;
    case 'environment':
      return <VsjEnvironmentReading />;
    case 'property':
      return <VsjPropertyForm />;
    case 'result':
      return <VsjResultStep />;
  }
}

function VsjFrame(): JSX.Element {
  const { step } = useVsjFlow();
  const mapVisible = step === 'location' || step === 'environment';

  return (
    <div className="vsj-frame">
      {/* One persistent map scene for location + reading: the city never reloads
          between confirming the place and reading its environment. */}
      {mapVisible && <VsjMapStage />}
      <VsjStepRenderer />
    </div>
  );
}

export function VsjExperienceShell(): JSX.Element {
  const { state } = useLocation();
  const preloaded = (state as RouteState | null)?.preloadedPlace;

  return (
    <VsjFlowProvider initialPlace={preloaded} initialStep={preloaded ? 'location' : 'home'}>
      <div className="vsj-shell">
        <VsjFrame />
      </div>
    </VsjFlowProvider>
  );
}
